import styled from 'styled-components'

export const Container = styled.div`
  margin-bottom: 60px;

  .button-group {
    width: 100%;
    padding-top: 24px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;

    button {
      margin: 0;
      max-width: 100%;
    }
  }

  .grid-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 32px;

    .grid {
      width: 50%;
      text-align: left;

      &.align-right {
        text-align: right;
      }
    }

    .list-item {
      color: #646464;
      font-weight: 500;
      letter-spacing: 0.4px;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 8px;

      .title {
      }

      .value {
        font-weight: 700;
      }
    }
  }
`

export const CollapseContainer = styled.div`
  width: 100%;
`
